export const COMMUNITY_LAST_SEEN_KEY = 'liwaza_community_last_seen';

export const readCommunityLastSeen = () => {
  const raw = Number(localStorage.getItem(COMMUNITY_LAST_SEEN_KEY) || 0);
  return Number.isFinite(raw) ? raw : 0;
};

export const markCommunityQuestionsSeen = (now = Date.now()) => {
  localStorage.setItem(COMMUNITY_LAST_SEEN_KEY, String(now));
};

export const normalizeCommunityPosts = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.posts)) return payload.posts;
  return [];
};

export const countNewCommunityQuestions = (posts, lastSeenMs = readCommunityLastSeen()) => {
  const list = Array.isArray(posts) ? posts : [];
  if (!lastSeenMs) {
    return list.length;
  }
  return list.filter((post) => {
    const created = new Date(post?.created_at || post?.createdAt || 0).getTime();
    return Number.isFinite(created) && created > lastSeenMs;
  }).length;
};
